module.exports = __webpack_public_path__ + "img/notMsg.a61b77ec.png";